/** Saved chat cards may predate the server's explicit size-adjusted fields. */
export interface ScorableBattleItem {
  priceA: number;
  priceB: number;
  priceAAtSizeB?: number | null;
  sizeComparable?: boolean;
  normalizedRatio?: number;
  unitAnalysis?: { isSameSize: boolean; normalizedRatio: number };
}

export function battleItemValue(item: ScorableBattleItem) {
  if (item.sizeComparable === false || item.priceAAtSizeB === null) return null;
  if (item.priceAAtSizeB !== undefined) return item.priceAAtSizeB;
  const ratio = item.normalizedRatio ?? item.unitAnalysis?.normalizedRatio ?? 1;
  return Number.isFinite(ratio) && ratio > 0 ? item.priceA / ratio : null;
}

export function summarizeBattleItems(items: ScorableBattleItem[]) {
  let totalA = 0;
  let totalB = 0;
  let itemCount = 0;
  let sizeAdjusted = false;
  for (const item of items) {
    const value = battleItemValue(item);
    if (value === null) continue;
    // Same basis as the server: the smaller package, so store order can't flip the winner.
    const ratio = item.priceA / value;
    if (ratio > 1) {
      totalA += value;
      totalB += item.priceB;
    } else {
      totalA += item.priceA;
      totalB += item.priceB * (Number.isFinite(ratio) ? ratio : 1);
    }
    itemCount++;
    sizeAdjusted ||= item.unitAnalysis?.isSameSize === false;
  }
  return { totalA, totalB, itemCount, sizeAdjusted, excludedCount: items.length - itemCount };
}
